<template>
    <GenericForm
        :fields="fields"
        :asyncErrors="asyncErrors"
        :asyncFieldError="asyncFieldError"
        @submit="$listeners.submit"
        class="registration-section"
    >
        <template slot-scope="slotProps">
            <div class="registration-section__inputs">
                <div class="registration-section__wrapper">
                    <BasicInfo
                        :firstName.sync="fields.firstName.value"
                        :lastName.sync="fields.lastName.value"
                        :email.sync="fields.email.value"
                        :username.sync="fields.username.value"
                        :password.sync="fields.password.value"
                        :errors="slotProps.errors"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                </div>
                <div class="registration-section__wrapper">
                    <div class="registration-section__form-group-title">
                        {{ $t('details of your residence for regulatory purposes') | capitalize }}
                    </div>
                    <div class="registration-section__form-group-inputs">
                        <Nationality
                            :nationality.sync="fields.nationality.value"
                            :errors="slotProps.errors"
                            @valueChanged="slotProps.onValueChanged"
                            @blur="slotProps.onBlur"
                        />
                        <template v-if="isPolish">
                            <Id
                                :pesel.sync="fields.pesel.value"
                                :errors="slotProps.errors"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                            <Country
                                :country.sync="fields.country.value"
                                :errors="slotProps.errors"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                        </template>
                        <template v-else-if="fields.nationality.value">
                            <CustomInput
                                name="documentNumber"
                                :value="fields.documentNumber.value"
                                label="ID or passport number"
                                :errorMessage="slotProps.errors.documentNumber"
                                @input="fields.documentNumber.value = $event"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                            <CustomInput
                                name="dateOfBirth"
                                :value="fields.dateOfBirth.value"
                                label="date of birth"
                                :errorMessage="slotProps.errors.dateOfBirth"
                                placeholder="DD/MM/YYYY"
                                @input="fields.dateOfBirth.value = $event"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                            <Country
                                :country.sync="fields.country.value"
                                :errors="slotProps.errors"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                            <Address
                                :country.sync="fields.country.value"
                                :county.sync="fields.county.value"
                                :city.sync="fields.city.value"
                                :postalCode.sync="fields.postalCode.value"
                                :address.sync="fields.address.value"
                                :isLivingInPoland="isLivingInPoland"
                                :errors="slotProps.errors"
                                @valueChanged="slotProps.onValueChanged"
                                @blur="slotProps.onBlur"
                            />
                        </template>
                    </div>
                </div>
                <div class="registration-section__wrapper privacy__container">
                    <TermsAndConditions
                        :termsAgree.sync="fields.termsAgree.value"
                        :customMarketingConsent.sync="fields.customMarketingConsent.value"
                        :receiveOperatorEmailConsent.sync="fields.receiveOperatorEmailConsent.value"
                        :receiveOperatorSMSConsent.sync="fields.receiveOperatorSMSConsent.value"
                        :errors="slotProps.errors"
                        @valueChanged="slotProps.onValueChanged"
                        @blur="slotProps.onBlur"
                    />
                    <PrivacyConsentWithdrawalInfo/>
                </div>
            </div>
            <Submit
                :isLoading="isLoading"
                :errors="slotProps.errors"
            />
        </template>
    </GenericForm>

</template>

<script>
    import BasicInfo from '@modules/authentication/components/register/BasicInfo';
    import Id from '@countryModules/authentication/components/register/Id';
    import Country from '@countryModules/authentication/components/register/Country';
    import Nationality from '@countryModules/authentication/components/register/Nationality';
    import Address from '@countryModules/authentication/components/register/Address';
    import TermsAndConditions from '@countryModules/authentication/components/register/TermsAndConditions';
    import Submit from '@modules/authentication/components/register/Submit';
    import config from '@config';

    export default {
        props: {
            fields: {
                type: Object,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
            asyncErrors: {
                type: Object,
                required: true,
            },
            asyncFieldError: {
                type: Object,
                required: true,
            },
            isPolish: {
                type: Boolean,
                reguired: true,
            }
        },
        computed: {
            isLivingInPoland() {
                return this.fields.country.value === config.countrySpecific.auth.polandId;
            },
        },
        components: {
            BasicInfo,
            Id,
            Country,
            TermsAndConditions,
            Submit,
            Nationality,
            Address,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/components/register/MainForm.vue